import { Action } from 'store/store';
import { WidgetType } from 'widgets/WidgetType';
import { AnyAction } from 'redux';

export enum WidgetActionType {
    WIDGET_SET_CONFIG = 'WIDGET_SET_CONFIG',
    WIDGET_LOAD_CONFIG = 'WIDGET_LOAD_CONFIG',
    WIDGET_SET_SHARED_CONFIG = 'WIDGET_SET_SHARED_CONFIG',
    WIDGET_LOAD_SHARED_CONFIGS = 'WIDGET_LOAD_SHARED_CONFIGS',
    WIDGET_SET_COMPONENT_STATE = 'WIDGET_SET_COMPONENT_STATE',
    WIDGET_WATCH_STREAM = 'WIDGET_WATCH_STREAM',
    WIDGET_RECEIVE_STREAM_MESSAGE = 'WIDGET_RECEIVE_STREAM_MESSAGE',
    WIDGET_RECEIVE_STREAM_MESSAGE_BATCH = 'WIDGET_RECEIVE_STREAM_MESSAGE_BATCH',
    WIDGET_CLEAR_STREAM_DATA = 'WIDGET_CLEAR_STREAM_DATA',
    WIDGET_SET_STREAM_DATA = 'WIDGET_SET_STREAM_DATA',
    WIDGET_RECEIVE_RPC_STREAM_RESPONSE = 'WIDGET_RECEIVE_RPC_STREAM_RESPONSE',
    WIDGET_SET_GRID_COLUMN_WIDTH = 'WIDGET_SET_GRID_COLUMN_WIDTH',
    WIDGET_TOGGLE_GRID_COLUMN_SORT = 'WIDGET_TOGGLE_GRID_COLUMN_SORT',
    WIDGET_TOGGLE_GRID_SINGLE_COLUMN_SORT = 'WIDGET_TOGGLE_GRID_SINGLE_COLUMN_SORT',
    WIDGET_HANDLE_STREAM_ERROR = 'WIDGET_HANDLE_STREAM_ERROR',
    WIDGET_SET_SHARED_STATE = 'WIDGET_SET_SHARED_STATE',
    WIDGET_CLEANUP_SHARED_STATE = 'WIDGET_CLEANUP_SHARED_STATE',
    WIDGET_RESET_INSTANCES_STATE = 'WIDGET_RESET_INSTANCES_STATE',
}

export interface WidgetActionPayload {
    widgetKey: string;
}

export interface WidgetTypeActionPayload extends WidgetActionPayload {
    widgetType: WidgetType;
}

export type WidgetTypeAction<
    TPayload extends WidgetTypeActionPayload,
    TActionType = WidgetActionType,
> = Action<TActionType, TPayload>;

export interface SetConfigPayload<TConfig> extends WidgetActionPayload {
    configDelta: Partial<TConfig>;
}

export interface SetConfigAction<TActionType, TConfig>
    extends Action<TActionType, SetConfigPayload<TConfig>> {
    payload?: SetConfigPayload<TConfig>;
}

export function isSetConfigActionFor(
    widgetType: WidgetType,
    action: AnyAction
): boolean {
    return (
        action.type === WidgetActionType.WIDGET_SET_CONFIG &&
        widgetType === (action.payload! as WidgetTypeActionPayload).widgetType
    );
}

export function isSetOrLoadConfigActionFor(
    widgetType: WidgetType,
    action: AnyAction
): boolean {
    return (
        (action.type === WidgetActionType.WIDGET_SET_CONFIG ||
            action.type === WidgetActionType.WIDGET_LOAD_CONFIG) &&
        widgetType === (action.payload! as WidgetTypeActionPayload).widgetType
    );
}

export type ResetWidgetInstancesState =
    Action<WidgetActionType.WIDGET_RESET_INSTANCES_STATE>;

export const createResetWidgetInstancesState: () => ResetWidgetInstancesState =
    () => ({ type: WidgetActionType.WIDGET_RESET_INSTANCES_STATE });
